var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import styled from 'styled-components';
import { Container as DSContainer } from '@olxbr/ds-web';
export var Container = styled(DSContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\npadding: 0px;\n"])));
export var ImageContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nheight: 64px;\noverflow: hidden;\n"])));
export var Image = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\nwidth: 100%;\nheight: 100%;\nobject-fit: cover;\n"])));